(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6166],{

/***/ 1793:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/actors",
      function () {
        return __webpack_require__(533);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _modules_hooks_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1306);
/* harmony import */ var _styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7768);
/* harmony import */ var _styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var Actors = function() {
    var ref = (0,_modules_hooks_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("actors"), t = ref.t, locale = ref.locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "actors | 볼리"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "actors | 볼리"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().banner),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: t("title")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: t("subTitle")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().notice),
                children: [
                    t("bannerText")[0],
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                        className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().mobile)
                    }),
                    t("bannerText")[1]
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().section),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                        children: [
                            t("reasonsSection").title[0],
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                                className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().mobile)
                            }),
                            t("reasonsSection").title[1]
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().list),
                        children: t("reasonsSection").reasons.map(function(item, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().item),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().no),
                                        children: index + 1
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().text),
                                        children: item.text
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().banner2),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "/VOLI-actors.png",
                            alt: "VOLI actors",
                            width: 110,
                            height: 20
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        children: [
                            t("banner2Text")[0],
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                                className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().mobile)
                            }),
                            t("banner2Text")[1]
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().section),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                        children: t("voiceMarketplaceSection").title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/images/actors/tag_".concat(locale, ".webp"),
                        alt: "",
                        width: 960,
                        height: 520,
                        loading: "eager"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().list),
                        children: t("voiceMarketplaceSection").marketPlace.map(function(item, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().item),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().no),
                                        children: index + 1
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                                        children: [
                                            item.title,
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                children: [
                                                    "\xa0\xa0\xa0",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                                                        className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().mobile)
                                                    }),
                                                    item.subTitle
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().text),
                                        children: item.text
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().voli),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_styles_actors_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                        children: t("title")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/VOLI-primary.png",
                        width: 151,
                        height: 49
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Actors);


/***/ }),

/***/ 7768:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pc":"actors_pc__axrAl","mobile":"actors_mobile__K8NjS","hide":"actors_hide__vbfO4","banner":"actors_banner__mNnR_","notice":"actors_notice__7RDwK","section":"actors_section__qQQ6H","title":"actors_title__f_hH9","list":"actors_list__bob_p","item":"actors_item__RML77","no":"actors_no__9uTiH","text":"actors_text__Jvqzt","banner2":"actors_banner2__G2msj","voli":"actors_voli__egpJF"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,9774,2888,179], function() { return __webpack_exec__(1793); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);